import { render, staticRenderFns } from "./MyAddresses.vue?vue&type=template&id=20c992d3&scoped=true&"
import script from "./MyAddresses.vue?vue&type=script&lang=js&"
export * from "./MyAddresses.vue?vue&type=script&lang=js&"
import style0 from "./MyAddresses.vue?vue&type=style&index=0&id=20c992d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c992d3",
  null
  
)

export default component.exports